import GenericAnalogSensor, { defaultGenericAnalogSensor } from './GenericAnalogSensor';

export default interface WeightSensor extends GenericAnalogSensor {
  '@type': 'weight_sensor';
}

const { '@type': _, ...defaultSensorWithoutType } = defaultGenericAnalogSensor;

export const defaultWeightSensor: WeightSensor = {
  '@type': 'weight_sensor',
  ...defaultSensorWithoutType,
};
